import React from "react";
export const withHooks = (Component, ...useHooks) => (props) => {
    let hooks = {};
    useHooks.forEach((useHook) => {
        const hook = useHook();
        hooks = { ...hooks, ...hook };
    });
    return <Component {...hooks} {...props}/>;
};
